import { getAllLayers, updateLayerTier } from '@/api/api.js';

export const state = {
  headers: [
    {
      text: 'Layer name',
      align: 'start',
      sortable: true,
      value: 'layer_name'
    },
    { text: 'Tier', value: 'tier', sortable: true },
    { text: 'Actions', value: 'actions', sortable: false, width: 130 }
  ],
  layers: []
};

export const mutations = {
  SET_LAYER_CATALOG(state, layers) {
    state.layers = layers;
  },
  UPDATE_LAYER_CATALOG_TIER(state, updatedLayer) {
    const layer = state.layers.find(
      element => element.layer_name === updatedLayer.layer_name
    );

    if (layer) {
      layer.tier = updatedLayer.tier;
    }
  }
};

export const actions = {
  async storeAllLayers({ commit, dispatch }) {
    try {
      const layers = await getAllLayers();

      commit('SET_LAYER_CATALOG', layers.data.listAllLayers);
    } catch (err) {
      dispatch(
        'storeToastMessage',
        {
          text: 'storeAllLayers',
          errObj: err,
          type: 'danger'
        },
        { root: true }
      );
    }
  },

  async storeLayerTier({ commit, dispatch }, { layer_name, tier }) {
    try {
      const updatedLayer = await updateLayerTier(layer_name, tier);

      dispatch(
        'storeToastMessage',
        {
          text: 'layer tier updated',
          type: 'success'
        },
        { root: true }
      );
      commit('UPDATE_LAYER_CATALOG_TIER', updatedLayer.data.updateLayerTier);
    } catch (err) {
      dispatch(
        'storeToastMessage',
        {
          text: 'storeLayerTier',
          errObj: err,
          type: 'danger'
        },
        { root: true }
      );
    }
  }
};

export const getters = {};
